export class GameError extends Error {
    constructor(message, helpText) {
        super(message);
        this.helpText = helpText;
    }
}
